export default {
  path: '/material_media',
  name: 'material_media',
  component: () => import('../components/materialmedium/Layout'),
  redirect: { name: 'MaterialMediumList' },
  meta: {
    breadcrumb: 'profile.material.mediums',
  },
  children: [
    {
      name: 'MaterialMediumList',
      path: '',
      component: () => import('../views/materialmedium/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialMediumCreate',
      path: 'new',
      component: () => import('../views/materialmedium/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialMediumUpdate',
      path: ':id/edit',
      component: () => import('../views/materialmedium/Update'),
      meta: {
        breadcrumb: 'profile.material.medium',
      },
    },
    {
      name: 'MaterialMediumShow',
      path: ':id',
      component: () => import('../views/materialmedium/Show'),
      meta: {
        breadcrumb: 'profile.material.medium',
      },
    }
  ]
};
